export const FIND_ARCHIVE_SAGA: 'FIND_ARCHIVE_SAGA' = 'FIND_ARCHIVE_SAGA'
export const FETCH_ARCHIVE_SUCCEEDED: 'FETCH_ARCHIVE_SUCCEEDED' = 'FETCH_ARCHIVE_SUCCEEDED'
export const FETCH_ARCHIVE_FAILED: 'FETCH_ARCHIVE_FAILED' = 'FETCH_ARCHIVE_FAILED'
export const FETCH_ARCHIVE_PENDING: 'FETCH_ARCHIVE_PENDING' = 'FETCH_ARCHIVE_PENDING'

export const CLEAR_ARCHIVE_DATA: 'CLEAR_ARCHIVE_DATA' = 'CLEAR_ARCHIVE_DATA'
